/** @jsx createElement */
import { observer } from 'mobx-react';
import { createElement, Component, HTMLAttributes } from 'react';
import ReactDOM from 'react-dom';
import { KeyboardShortcuts } from '../keyboard-shortcuts';
import anime from 'animejs';
import { activate, deactivate, shimmer, activateShimmer } from '../helpers';
import { AnimatedSlide } from '../animated-slide';

// Players
import { PlayerCircleIcon } from '../players/circle-icon';
import { PlayerTextBlock } from '../players/text-block';

// Icons
import { Directory } from '../svg/directory';
import { Code2 } from '../svg/code2';

@observer
export class Slide13 extends AnimatedSlide {
  // Animation players
  players = {
    folder: null,
    payload: null,
    results: null,
  };

  // Run the first animation
  componentDidMount() {
    const { folder, payload, results } = this.players;

    this.steps = [
      // Step 1
      () => {
        this.animateProgress(4000);
        this.autoNext(1000);
      },
      // Step 2
      () => {
        this.autoNext(2000);
      },
      // Step 3
      () => {},
    ];

    this.animations = [
      //
      // Step 1
      //
      [],
      //
      // Step 2
      //
      [
        {
          targets: payload,
          opacity: 1,
          delay: 0,
          duration: 200,
          begin: activateShimmer,
        },
      ],
      //
      // Step 3
      //
      [
        {
          targets: results,
          opacity: 1,
          delay: 0,
          duration: 200,
          begin: activateShimmer,
        },
      ],
    ];

    // Play the first animation
    this.play();
  }

  render() {
    const { children, className = '' } = this.props;

    return (
      <div className={`slide-13 ${className}`}>
        {children}
        <div className="content">
          {/* Results (SURICATA) */}
          <div
            className="player results"
            data-active="0"
            ref={node => (this.players.results = node)}
          >
            <PlayerTextBlock
              title={'Results (BRO)'}
              className={'section-grid'}
              sections={[
                {
                  lines: 3,
                  lineColumns: 2,
                },
                {
                  lines: 3,
                  lineColumns: 2,
                },
                {
                  lines: 3,
                },
                {
                  lines: 3,
                },
                {
                  lines: 3,
                  lineColumns: 2,
                },
                {
                  lines: 3,
                  lineColumns: 2,
                },
              ]}
            />
          </div>

          {/* Payload Info */}
          <div
            className="player payload"
            data-active="0"
            ref={node => (this.players.payload = node)}
          >
            <PlayerTextBlock
              title={'Payload Info'}
              showDots={true}
              sections={[
                {
                  title: '64125fdd2cf70f3ea534860',
                },
              ]}
            />
          </div>

          {/* Folder */}
          <div
            className="player folder"
            data-active="1"
            ref={node => (this.players.folder = node)}
          >
            <PlayerCircleIcon
              color={'#ffffff'}
              Icon={Code2}
              IconSize={'50'}
              showTitle={false}
            />
          </div>
        </div>
      </div>
    );
  }
}
